import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import ChangePasswordForm from '../../components/changePasswordForm/changePasswordForm';
import BackButton from '../../components/backButton/backButton';

const ResetPassword = () => (
  <Container className="register-page page-container">
    <BackButton to="/log-in" />
    <div className="title-wrapper">
      <Typography variant="h3">
        Zmiana hasła
      </Typography>
    </div>
    <Paper className="paper-box">
      <Container>
        <ChangePasswordForm />
      </Container>
    </Paper>
  </Container>
);

export default ResetPassword;
